class WishlistPage extends HTMLElement {
	constructor() {
		super();

		this.isDevelopment = Shopify.theme.role === 'development';
		this.wishlistAPI = `${
			this.isDevelopment ? 'http://localhost:8080' : 'https://cors.vevolmedia.com'
		}/fyne-jewellery/wishlist`;
		this.fyneJewelleryJson = 'https://www.fynejewellery.com/products.json?limit=250';
		this.initBodyData = {
			dataSource: 'Cluster0',
			database: 'fyne-jewellery',
			collection: 'wishlist',
		};
		this.accountId = document.querySelector('.vm-customerId').value;
		this.wishlistSection = document.querySelector('#wishlist-page');
		this.removeAll = document.querySelector('.wishlist-all__remove');
		this.footerBtns = document.querySelector('.wishlist-all');
		this.modal = document.querySelector('.modal-loader');
		this.root = this.querySelector('.wishlist-root');
		this.removeAll.addEventListener('click', this.clearWishlist.bind(this));

		this.render();
	}

	async getItemsFromJson() {
		try {
			const res = await fetch(this.fyneJewelleryJson);
			const resJson = await res.json();
			return resJson.products;
		} catch (error) {
			console.error(error);
		}
	}

	async getWishlist() {
		try {
			const res = await fetch(`${this.wishlistAPI}/get`, {
				method: 'POST',
				body: JSON.stringify({
					...this.initBodyData,
					filter: { account_id: this.accountId },
				}),
			});
			const resJson = await res.json();
			const wishlistIds = resJson.document?.wishlist_ids;
			return wishlistIds;
		} catch (error) {
			console.error(error);
		}
	}

	async displayItemsFromWishlist() {
		this.modal.style.display = 'block';
		const itemsFromJson = await this.getItemsFromJson();
		const itemsFromDb = await this.getWishlist();
		let wishlistItems = [];

		if (itemsFromDb) {
			itemsFromJson.forEach((value, index) => {
				if (itemsFromDb.includes(value.id.toString())) {
					wishlistItems.push(itemsFromJson[index]);
				}
			});
		}
		this.modal.style.display = 'none';
		return wishlistItems;
	}

	async deleteItem(itemId) {
		const removeItem = (value) => value !== itemId;
		let list;
		const localList = JSON.parse(localStorage.getItem('wishlistData'));

		// In case of local storage deletion we use the data from Db
		if (localList !== null) {
			list = localList;
		} else {
			list = await getWishlist();
		}

		const localData = {
			accountId: this.accountId,
			wishlistIds: list.wishlistIds.filter(removeItem),
		};

		this.modal.style.display = 'block';
		localStorage.setItem('wishlistData', JSON.stringify(localData));

		try {
			const localList = JSON.parse(localStorage.getItem('wishlistData'));
			fetch(`${this.wishlistAPI}/update`, {
				method: 'POST',
				body: JSON.stringify({
					...this.initBodyData,
					filter: { account_id: this.accountId },
					update: {
						account_id: this.accountId,
						timestamp: timestamp,
						wishlist_ids: localList.wishlistIds,
					},
				}),
			}).then(() => this.render());
		} catch (error) {
			console.error(error);
		}

		return;
	}

	clearWishlist() {
		const localData = {
			accountId: this.accountId,
			wishlistIds: [],
		};

		localStorage.setItem('wishlistData', JSON.stringify(localData));
		try {
			fetch(`${this.wishlistAPI}/update`, {
				method: 'POST',
				body: JSON.stringify({
					...this.initBodyData,
					filter: { account_id: this.accountId },
					update: {
						account_id: this.accountId,
						timestamp: timestamp,
						wishlist_ids: [],
					},
				}),
			}).then(() => this.render());
		} catch (error) {
			console.error(error);
		}
	}

	attachListeners() {
		const deleteItemFromWishlist = this.wishlistSection.querySelectorAll('.wishlist-buttons__delete');

		deleteItemFromWishlist.forEach((btn) =>
			btn.addEventListener('click', async () => {
				const prodId = btn.dataset.id;
				await this.deleteItem(prodId);
			})
		);

		document.dispatchEvent(
			new CustomEvent('wishlist-page-mounted', {
				detail: { element: this.wishlistSection },
			})
		);
	}

	numberWithCommas(x) {
		let parts = x.toString().split('.');

		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

		if (parts[parts.length - 1] == '00' || parts[parts.length - 1] == '0') {
			return parts[0];
		} else {
			return parts.join('.');
		}
	}

	async render() {
		this.wishlist = await this.displayItemsFromWishlist();
		const wishlistEmpty = this.wishlist.length === 0;
		this.modal.style.display = 'none';

		this.renderWishlist;

		if (wishlistEmpty) {
			this.renderWishlist = `<div class="wishlist-empty">There are no items in this wishlist</div>`;
			this.footerBtns.style.display = 'none';
		} else {
			this.footerBtns.style.display = 'block';
			this.renderWishlist = this.wishlist
				.map(
					(card) => `
			<li class="wishlist-card" data-id="${card.id}">
				<a class="wishlist-card__link-wrapper" href=/products/${card.handle}>
					<div class="wishlist-card__content">
						<h2 class="wishlist-card__title">${card.title}</h2>
					</div>
					<div class="wishlist-card__img">
						<img src="${card.images[0].src}" alt="${card.title}"/>
					</div>
					<div class="wishlist-card__price">
					<span class="money">${this.numberWithCommas(card.variants[0].price)} AED</span>
					</div>
				</a>

				<div class="wishlist-buttons">
					<a href=/products/${card.handle} class="wishlist-buttons__cart btn btn--primary btn--solid" >
						<span >View product</span>
					</a>
					<button class="wishlist-buttons__delete" type="button" data-id="${card.id}">
						<span >
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3 6l3 18h12l3-18h-18zm19-4v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.316c0 .901.73 2 1.631 2h5.711z"/></svg>
						</span>
					</button>
				</div>
			</li>
		`
				)
				.join('\n');
		}

		this.wishlistSection.innerHTML = `
			<ul class="wishlist-root">
				${this.renderWishlist}
			</ul>
		`;

		this.attachListeners();
	}
}

customElements.define('wishlist-page', WishlistPage);
